import { CUSTOMER_JOURNEY_WEATHER, CUSTOMER_JOURNEY_WEATHER_SUCCESS, CUSTOMER_JOURNEY_WEATHER_ERROR } from './../../actions/const';
import { SET_TOKEN, SET_LANG } from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: {},
  loading: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_WEATHER: {
      nextState.loading = true;
      nextState.apiData = {};
      CustomerJourneySource.weather(action.token, action.lang, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_WEATHER_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_WEATHER_ERROR: {
      nextState.loading = false;
      nextState.apiData = {};
      return nextState;
    }
    case SET_TOKEN:
    case SET_LANG: {
      if(!isEmpty(state.apiData)) {
        nextState.loading = true;
        nextState.apiData = {};
        CustomerJourneySource.weather(action.token, action.lang, action.context);
        return nextState;
      }
      else {
        return state;
      }
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/weather.js